import { ENV } from '@lib/env'

// test hooks for the dev target only, unless a label applies everywhere
export const accessibilityLabel = (devLabel: string, defaultLabel?: string) => {
  const value = (ENV.target === 'dev' && devLabel) || defaultLabel
  return value ? { accessibilityLabel: value, testID: value } : {}
}

// on the web a role is just the role
export const accessibilityRole = (role: string) => role as any

// appends styles to a react-native style prop, which may be an array
export const addStyles = <Style>(style: Style | Style[], additional: Style) => {
  const styles = Array.isArray(style) ? [...style] : [style]
  styles.push(additional)
  return styles
}
